/* eslint-disable no-unused-vars */

import React, { useState } from 'react';
import { Form, Input, StyledClose, StyledSearch } from './styles';
import { useEffect } from 'react';

const SearchSecondary = ({ placeholder, onSearch, searchFieldIsInUse, isLoading, list, minSubmitChars, onClose, ...rest }) => {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (!searchFieldIsInUse) {
      setInputValue('');
    }
  }, [searchFieldIsInUse]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSearch = (e) => {
    e.preventDefault();

    if (inputValue.length >= (minSubmitChars ?? 3) && !isLoading) {
      onSearch(inputValue);
    }
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
  };

  const handleClose = (e) => {
    e.preventDefault();

    if (!isLoading) {
      onClose();
    }
  }


  return (
    <Form onSubmit={handleSearch}>
      <Input
        value={inputValue}
        onChange={handleInputChange}
        placeholder={placeholder || 'Buscar'}
        id="search"
        label="Outlined"
        variant="outlined"
        disabled={isLoading}
        {...rest}
      />
      {searchFieldIsInUse && list.length > 0 ? (
        <StyledClose onMouseDown={isLoading ? () => { } : handleMouseDown} onClick={handleClose} />
      ) : (
        <StyledSearch onMouseDown={isLoading ? () => { } : handleMouseDown} onClick={handleSearch} />
      )}
    </Form>
  );
}

export default SearchSecondary;
